import React, { ReactElement } from 'react';
import { SortSelect } from 'slovlex-idsk-react-components';
import { sortValuesPredbezne } from '../../../../constants/SortConstants';

const PredbeznaInformaciaListSort = (): ReactElement => (
  <SortSelect sortList={[
    {
      sort: sortValuesPredbezne[0],
      title: 'Vyjadrenia (od najnovších)',
      sortBy: 'desc',
    },
    {
      sort: sortValuesPredbezne[0],
      title: 'Vyjadrenia (od najstarších)',
      sortBy: 'asc',
    },
    {
      sort: sortValuesPredbezne[1],
      title: 'Začiatok štádia (od najnovších)',
      sortBy: 'desc',
    },
    {
      sort: sortValuesPredbezne[1],
      title: 'Začiatok štádia (od najstarších)',
      sortBy: 'asc',
    },
    {
      sort: sortValuesPredbezne[2],
      title: 'Názov (A-Z)',
      sortBy: 'asc',
    },
    {
      sort: sortValuesPredbezne[2],
      title: 'Názov (Z-A)',
      sortBy: 'desc',
    },
  ]}
  />
);

export default PredbeznaInformaciaListSort;
